import { ApiPerformanceReviewReviewerTypes } from "@/types/performance-review.types.ts";
import * as yup from "yup";

export enum PerformanceReviewEditPageStep {
  details = "details",
  reviewers = "reviewers",
  forms = "forms",
  settings = "settings",
  invitation = "invitation",
  ratings = "ratings",
  notifications = "notifications",
  final = "final",
}

export interface ReviewerTypeItem {
  id: number | null;
  title: string | null;
  description?: string;
  type: ApiPerformanceReviewReviewerTypes;
}

export interface PerformanceReviewInvitationContent {
  invitation_subject: string | null;
  invitation_body: string | null;
}

export const copyCommonInvitationToEmptyReviewerTypes = <
  T extends PerformanceReviewInvitationContent,
>(
  settings: T[],
  common: PerformanceReviewInvitationContent
): T[] =>
  settings.map((setting) =>
    !setting.invitation_subject?.trim() && !setting.invitation_body?.trim()
      ? { ...setting, ...common }
      : setting
  );

export const createPerformanceReviewInvitationSchemaFields = (
  requiredMessage: string,
  shouldValidate: (parent: Record<string, unknown>) => boolean = () => true
) => ({
  invitation_subject: yup
    .string()
    .nullable()
    .defined()
    .test("required-with-body", requiredMessage, function (value) {
      if (!shouldValidate(this.parent)) return true;
      const body = this.parent?.invitation_body;
      return !body?.trim() || Boolean(value?.trim());
    }),
  invitation_body: yup
    .string()
    .nullable()
    .defined()
    .test("required-with-subject", requiredMessage, function (value) {
      if (!shouldValidate(this.parent)) return true;
      const subject = this.parent?.invitation_subject;
      return !subject?.trim() || Boolean(value?.trim());
    }),
});
